import { ChevronRight, ChevronDown } from '@interhyp/platform-icons';
import classnames from 'classnames';
import { DefaultStartContent } from "./DefaultStartContent.js";
import styles from "./DataTreeBar.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function DataTreeBar({
  data,
  level,
  StartContent = DefaultStartContent,
  EndContent,
  chevron
}) {
  const isOpen = chevron === 'down';
  return /*#__PURE__*/_jsxs("div", {
    className: styles.bar,
    "data-testid": "data-tree-bar",
    children: [/*#__PURE__*/_jsxs("div", {
      className: classnames(styles.start, {
        [styles.noChevron]: !chevron
      }),
      children: [chevron && /*#__PURE__*/_jsxs("div", {
        className: styles.chevron,
        children: [chevron === 'right' && /*#__PURE__*/_jsx(ChevronRight, {}), chevron === 'down' && /*#__PURE__*/_jsx(ChevronDown, {})]
      }), /*#__PURE__*/_jsx(StartContent, {
        data: data,
        isOpen: isOpen,
        level: level
      })]
    }), EndContent && /*#__PURE__*/_jsx(EndContent, {
      data: data,
      isOpen: isOpen,
      level: level
    })]
  });
}